import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { updateSuggestions } from '../ui/utils/updateSuggestions';

import type { RefreshSuggestionsAction } from './types';

export const refreshSuggestionsAction = (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
	contentAri?: string,
): RefreshSuggestionsAction => {
	return (options?: { regenerateOnly?: boolean }): boolean => {
		if (!api) {
			return false;
		}

		const shouldRegenerate = fg('platform_editor_ai_suggested_edits_regeneration');
		const regenerateOnly = options?.regenerateOnly ?? false;

		// Regeneration is the only thing that was asked for, and it's gated off —
		// don't silently fall back to a fetch the caller didn't want.
		if (regenerateOnly && !shouldRegenerate) {
			return false;
		}

		/**
		 * Quick way to get the doc PMNode
		 * since we don't have access to editorView here
		 */
		const getDoc = (): PMNode | undefined => {
			let doc: PMNode | undefined;
			api.core?.actions.execute(({ tr }) => {
				doc = tr.doc;
				return null;
			});
			return doc;
		};
		updateSuggestions({
			api,
			contentAri,
			getDoc,
			shouldRegenerate,
			regenerateOnly,
		});
		return true;
	};
};
